import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isAuthResolved } = useAuth();
  const location = useLocation();

  // Espera a que se resuelva la validación inicial para evitar parpadeos
  if (!isAuthResolved) {
    return null;
  }

  if (!isAuthenticated) {
    // Redirigir al login si no está autenticado
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children; // Si está autenticado, muestra el componente
};

export default PrivateRoute;
